// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2R8-U","header":"PatientQuestionnaire_header__3Pb-8","info":"PatientQuestionnaire_info__2ojeL"};